export default function playVideo(node_url) {
    return fetch(`${node_url}/keycode/90/d`);
}
